import { Name } from 'types';

import { mapNameIntoOptions } from 'helpers/mapIntoOptions';

import { FormItem } from 'sections/EditForm';

const useDataForm = (priceList: Name[], userTypes: Name[]): FormItem[] => [
  {
    name: 'id',
    label: 'ID',
    disabled: true,
  },
  {
    name: 'surname',
    label: 'Last Name',
    required: true,
  },
  {
    name: 'name',
    label: 'Name',
    required: true,
  },
  {
    name: 'email',
    label: 'email',
    required: true,
  },
  {
    name: 'userType.id',
    label: 'Department',
    options: mapNameIntoOptions(userTypes),
    type: 'select',
  },
  {
    name: 'priceList.id',
    label: 'Price List',
    options: mapNameIntoOptions(priceList),
    type: 'select',
  },
  {
    name: 'customerName',
    label: 'Company Name',
  },
  {
    name: 'vatNumber',
    label: 'P.IVA / VAT',
  },
  {
    name: 'fiscalCode',
    label: 'Fiscal Code',
  },
  {
    name: 'phoneNumber',
    label: 'Telephone Number',
  },
  {
    name: 'mobileNumber',
    label: 'Mobile Phone Number',
  },
  {
    name: 'bio',
    label: 'Bio',
    type: 'textbox',
  },
];

export { useDataForm };
